import type { FetchLike } from '../core/api.js';

/** Same-origin by default (client is served by the relay); override for local dev. */
export const GONZO_BASE: string = (import.meta.env?.VITE_GONZO_BASE as string | undefined) ?? '';

export const browserFetch: FetchLike = (url, init) => fetch(url, init as RequestInit);
